
import React, { Component } from 'react';
import ReactDOM from 'react-dom';
var redirectURL = require('../redirectURL');


const RoutemapenrouteAction = (props) => {
    const handleClick = (e) => {
        e.stopPropagation();
        console.log("Props ", props);
        props.agGridReact.props.gridOptions.context.componentParent.onShowEnrouteRouteMap(props.data);
    };

    return (
        <div>
			<button onClick={handleClick} className="custom-btn label label-success"><i className="icofont icofont-map-pins f20"></i> </button>
       
        </div>
    );
};

export default RoutemapenrouteAction;
